import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import RoleService from '../Services/roleService';

export default class OpportunityCommissionRateItem {
  constructor(item) {
    if (item === undefined) {
      this.PrimarySalesRepId = null;
      this.PrimarySalesRepName = null;
      this.ExternalSalesPartnerId = null;
      this.ExternalSalesPartnerName = null;
      this.OpportunityId = null;
      this.OpportunityCurrency = null;
      this.OpportunityStatus = null;
      this.ServiceId = null;
      this.CommissionYearPeriod = null;
      this.CommissionRateId = null;
      this.CommissionRate = null;
      this.CommissionRateClosedOn = null;
      this.PlannedAmount = null;
      this.ServiceCommissionRateApprovalStatus = null;
      this.ServiceCommissionRateApprovalStatusString = null;
      this.CommissionApprover = null;
      this.CommissionApproverName = null;
      this.Selected = false;
      return;
    }
    this.PrimarySalesRepId = item.primarySalesRepId;
    this.PrimarySalesRepName = item.primarySalesRepName;
    this.ExternalSalesPartnerId = item.externalSalesPartnerId;
    this.ExternalSalesPartnerName = item.externalSalesPartnerName;
    this.OpportunityId = item.opportunityId;
    this.OpportunityCurrency = item.opportunityCurrency;
    this.OpportunityStatus = item.opportunityStatus;
    this.ServiceId = item.serviceId;
    this.CommissionYearPeriod = item.commissionYearPeriod;
    this.CommissionRateId = item.commissionRateId;
    this.CommissionRate = item.commissionRate;
    this.CommissionRateClosedOn = item.commissionRateClosedOn;
    this.PlannedAmount = item.plannedAmount;
    this.ServiceCommissionRateApprovalStatus = item.serviceCommissionRateApprovalStatus;
    this.ServiceCommissionRateApprovalStatusString = item.serviceCommissionRateApprovalStatusString;
    this.CommissionApprover = item.commissionApprover;
    this.CommissionApproverName = item.commissionApproverName;
    this.Selected = false;
  }

  static MoneyFields = ['PlannedAmount'];

  static Currency() {
    return 'OpportunityCurrency';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: OpportunityCommissionRateItem.getSelectedCellHeader,
        orderById: '',
        data: OpportunityCommissionRateItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Primary Sales Rep.', orderById: 'PrimarySalesRepName', data: 'PrimarySalesRepName' },
      { label: 'External Sales Partner', orderById: 'ExternalSalesPartnerName', data: 'ExternalSalesPartnerName' },
      { label: 'Service ID', orderById: 'ServiceId', data: 'ServiceId', minWidth: 20 },
      { label: 'Commission Rate', orderById: 'CommissionRate', data: (item) => `${item.CommissionRate}%` },
      { label: 'Planned Amount', orderById: 'PlannedAmount', data: 'PlannedAmount' },
      {
        label: 'Approval Status',
        orderById: 'ServiceCommissionRateApprovalStatusString',
        data: 'ServiceCommissionRateApprovalStatusString',
      },
      {
        label: 'Approved By',
        orderById: 'CommissionApproverName',
        data: 'CommissionApproverName',
      },
      {
        label: ' ',
        orderById: '',
        data: OpportunityCommissionRateItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          OpportunityCommissionRateItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={OpportunityCommissionRateItem.selectedStatus()}
        onChange={(e) => {
          OpportunityCommissionRateItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Change Status',
            iconName: 'fa-solid fa-rotate-right',
            onClick: () => OpportunityCommissionRateItem.changeCommissionFunction(item),
            disabled:
              [11, 12].includes(item.OpportunityStatus) ||
              (item.ServiceCommissionRateApprovalStatus !== 1 &&
                !RoleService.CheckUserPermission('special_case', 'commissionrate_statusoverride')),
          },
        ]}
      />
    );
  }

  static changeCommissionFunction(item) {
    alert('Empty Function');
  }
}
